(function () {
  const deferredResources = [
    { "src": "youtube.com" },
    { "src": "adcell.com", "load": "onUserInteract" },
  ];

  const blockedResources = [
    {
      "key": "src",
      "val": "storelocator",
      "getShouldBlock": () => { return document.querySelector('#scasl-app-container') == null }
    },
    {
      "key": "src",
      "val": "yotpo",
      "getShouldBlock": () => { return document.querySelector('.yotpo-widget-instance, [data-yotpo-instance-id]') == null }
    }
  ];

  function shouldBlockResource(resource) {
    for (let i = 0; i < deferredResources.length; i++) {
      const blockedResource = deferredResources[i];
      if (window.deferredDone !== true || (blockedResource.load && !window.userInteracted)) {
        for (let key in blockedResource) {
          if (resource[key] && resource[key].indexOf(blockedResource[key]) !== -1) {
            return blockedResource.load || true;
          }
        }
      }
    }
    for (let i = 0; i < blockedResources.length; i++) {
      const blockedResource = blockedResources[i];
      if (
        blockedResource.getShouldBlock() &&
        ((resource.hasAttribute(blockedResource.key) && resource.getAttribute(blockedResource.key).indexOf(blockedResource.val) !== -1) ||
         (resource.hasAttribute("data-" + blockedResource.key) && resource.getAttribute("data-" + blockedResource.key).indexOf(blockedResource.val) !== -1))
      ) {
        return true;
      }
    }
    return false;
  }

  function shouldBlockKeyValue(key, value) {
    for (let i = 0; i < deferredResources.length; i++) {
      const blockedResource = deferredResources[i];
      if (window.deferredDone !== true || (blockedResource.load && !window.userInteracted)) {
        if (blockedResource[key] && value && value.indexOf(blockedResource[key]) !== -1) {
          return blockedResource.load || true;
        }
      }
    }
    for (let i = 0; i < blockedResources.length; i++) {
      const blockedResource = blockedResources[i];
      if (blockedResource.getShouldBlock() && blockedResource.key === key && value && value.indexOf(blockedResource.val) !== -1) {
        return true;
      }
    }
    return false;
  }

  function blockResourcesAsync() {
    const allElements = [
      ...document.querySelectorAll('script[type="text/javascript"],script:not([type])'),
      ...document.querySelectorAll('link[rel="stylesheet"]'),
      ...document.querySelectorAll('iframe')
    ];

    function processBatch(batch) {
      const chunk = batch.splice(0, 10);
      chunk.forEach((el) => {
        const shouldBlock = shouldBlockResource(el);
        if (shouldBlock) {
          if (typeof shouldBlock === "string") el.setAttribute('data-load', shouldBlock);
          if (el.tagName === "SCRIPT") {
            el.setAttribute('data-defer', "true");
            el.setAttribute('data-src', el.src);
            el.removeAttribute('src');
            el.type = "text/plain";
          } else if (el.tagName === "LINK") {
            el.setAttribute('data-href', el.href);
            el.href = '';
          } else if (el.tagName === "IFRAME") {
            el.setAttribute('data-src', el.src);
            el.removeAttribute('src');
          }
        }
      });

      if (batch.length > 0) {
        (window.requestIdleCallback || function (cb) { setTimeout(cb, 0); })(() => processBatch(batch));
      }
    }

    processBatch(allElements);
  }

  function reloadDeferredResources(load) {
    const scripts = load
      ? document.querySelectorAll(`script[data-src][data-load="${load}"],script[data-defer][data-load="${load}"]`)
      : document.querySelectorAll('script[data-src]:not([data-load]),script[data-defer]:not([data-load])');
    
    scripts.forEach((script) => {
      if (!shouldBlockResource(script)) {
        const newScript = document.createElement('script');
        script.getAttributeNames().forEach((key) => {
          if (key !== "data-src" && key !== "data-defer" && key !== "data-load") {
            newScript.setAttribute(key, script.getAttribute(key));
          }
        });
        if (script.hasAttribute('data-src')) {
          if (!script.hasAttribute("defer") && !script.hasAttribute("async")) {
            newScript.setAttribute('defer', '');
          }
          newScript.src = script.getAttribute('data-src');
        } else {
          newScript.innerHTML = script.innerHTML;
        }
        newScript.type = "text/javascript";
        document.body.appendChild(newScript);
        script.remove();
      }
    });

    const stylesheets = load
      ? document.querySelectorAll(`link[rel="stylesheet"][data-href][data-load="${load}"]`)
      : document.querySelectorAll('link[rel="stylesheet"][data-href]:not([data-load])');

    stylesheets.forEach((stylesheet) => {
      const newLink = document.createElement('link');
      newLink.rel = 'stylesheet';
      newLink.href = stylesheet.getAttribute('data-href') || stylesheet.href;
      newLink.media = 'print';
      newLink.onload = function () {
        this.media = 'all';
      };
      stylesheet.parentNode.removeChild(stylesheet);
      document.body.appendChild(newLink);
    });

    const iframes = load
      ? document.querySelectorAll(`iframe[data-src][data-load="${load}"]`)
      : document.querySelectorAll('iframe[data-src]:not([data-load])');

    iframes.forEach((iframe) => {
      iframe.src = iframe.getAttribute('data-src');
      iframe.removeAttribute('data-src');
    });
  }

  function handleUserInteraction() {
    window.userInteracted = true;
    document.removeEventListener("scroll", handleUserInteraction);
    document.removeEventListener("click", handleUserInteraction);
    document.removeEventListener("touchstart", handleUserInteraction);
    setTimeout(() => {
      reloadDeferredResources("onUserInteract");
    }, 500);
  }

  const createElementBackup = document.createElement;
  document.createElement = function (...args) {
    if (!['script', 'iframe', 'link'].includes(args[0].toLowerCase())) {
      return createElementBackup.bind(document)(...args);
    }

    const el = createElementBackup.bind(document)(...args);
    const originalSetAttribute = el.setAttribute.bind(el);

    Object.defineProperties(el, {
      'src': {
        get() { return el.getAttribute('src'); },
        set(value) {
          const shouldBlock = shouldBlockKeyValue('src', value);
          if (shouldBlock) {
            if (typeof shouldBlock === "string") {
              originalSetAttribute('data-load', shouldBlock);
            }
            originalSetAttribute('data-src', value);
          } else {
            originalSetAttribute('src', value);
          }
        }
      },
      'href': {
        get() { return el.getAttribute('href'); },
        set(value) {
          const shouldBlock = shouldBlockKeyValue('href', value);
          if (shouldBlock) {
            if (typeof shouldBlock === "string") {
              originalSetAttribute('data-load', shouldBlock);
            }
            originalSetAttribute('data-href', value);
          } else {
            originalSetAttribute('href', value);
          }
        }
      }
    });

    el.setAttribute = function (name, value) {
      if (name === 'src' || name === 'href') {
        el[name] = value;
      } else {
        (args[0] === 'script' ? HTMLScriptElement : args[0] === 'iframe' ? HTMLIFrameElement : HTMLLinkElement).prototype.setAttribute.call(el, name, value);
      }
    };

    return el;
  };

  // Initiales Blockieren starten
  blockResourcesAsync();

  document.onreadystatechange = function () {
    if (document.readyState === 'interactive') {
      blockResourcesAsync();
    }
    if (document.querySelector("[data-load]")) {
      document.addEventListener("scroll", handleUserInteraction, { passive: true });
      document.addEventListener("touchstart", handleUserInteraction, { passive: true });
      document.addEventListener("click", handleUserInteraction);
    }
  };

  window.addEventListener("DOMContentLoaded", function () {
    window.deferredDone = true;
    reloadDeferredResources();
  });

})();